export const getIconName = icon => {
  const name = { pin: 'map-pin' }[icon] || icon
  return name
    .split('-')
    .map(k => `${k[0].toUpperCase()}${k.slice(1, k.length)}`)
    .join('')
}
